import { render, staticRenderFns } from "./select-lab-order-dialog.vue?vue&type=template&id=0dcb1237"
import script from "./select-lab-order-dialog.vue?vue&type=script&lang=js"
export * from "./select-lab-order-dialog.vue?vue&type=script&lang=js"
import style0 from "./select-lab-order-dialog.vue?vue&type=style&index=0&id=0dcb1237&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports